import * as React from 'react';
import { Link } from 'gatsby';
import AngleRight from '../components/AngleRight';
import Date from '../components/Date';
import styled from 'styled-components';

const Heading = styled.h3`
	color: black;

	& a {
		color: black;
	}
`;

const Figure = styled.figure`
	text-align: center;
	margin: 0 auto 1em;
`;

const ExternalLinkArticle = ({ internalLink,
								href,
								banner,
								bannerAlt,
								heading,
								headingStyle,
								date,
								paragraph,
								readFullStory
							}) => (
	<article className='col-12 col-md-6'>
		{internalLink ? (
			<>
				<Figure>
					<Link to={href}>
						<img src={banner} alt={bannerAlt} />
					</Link>
				</Figure>
				<Date>{date}</Date>
				<Heading style={headingStyle}>{heading}</Heading>
				<p>{paragraph}</p>
				<Link to={href} className='animate-right'>
					Read the story<AngleRight />
				</Link>
			</>
		) : (
		<>
			<Figure>
				<a href={href} target='_blank' rel='noopener noreferrer'>
					<img src={banner} alt={bannerAlt} />
				</a>
			</Figure>
			<Date>{date}</Date>
			<Heading style={headingStyle}>{heading}</Heading>
			<p>{paragraph}</p>
			<a href={href} className='animate-right'>Read the story<AngleRight /></a>
		</>
		)}
	</article>
);

export default ExternalLinkArticle;
